import { useTranslation } from 'react-i18next'

import FormSection from '../../../../formSection/FormSection'
import { Button } from '../../../../buttons/Button'
import { PasswordInput } from '../../../../input/PasswordInput'
import { PasswordCreateInput } from '../../../../input/passwordCreateInput/PasswordCreateInput'

import { UpdatePasswordFormData } from '../../../../../types/user/userProfile'

type PasswordFormProps = {
  formData: UpdatePasswordFormData
  loading: boolean
  onChange: (name: string, value: string, isValid: boolean) => void
  onSubmit: () => void
}

const PasswordForm = ({
  formData,
  loading,
  onChange,
  onSubmit,
}: PasswordFormProps) => {
  const { t } = useTranslation('account')

  const isValid = Object.values(formData).every(input => input.isValid)

  return (
    <FormSection
      title={t('account.password.title')}
      actions={
        <Button
          label={t('account.password.update')}
          variant="primary"
          size="sm"
          block
          loading={loading}
          disabled={!isValid}
          onClick={onSubmit}
        />
      }
    >
      <div className="password-form">
        <div className="password-form-content">
          <div className="row g-3">
            <div className="col-12">
              <PasswordInput
                name="currentPassword"
                label={t('account.password.current')}
                value={formData.currentPassword.value}
                required
                onChange={onChange}
              />
            </div>
            <div className="col-12">
              <div className="password-form-password">
                <PasswordCreateInput
                  name="newPassword"
                  label={t('account.password.new')}
                  confirmLabel={t('account.password.confirm')}
                  value={formData.newPassword.value}
                  onChange={onChange}
                  errorMessage={t('account.password.not-match')}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </FormSection>
  )
}

export default PasswordForm
